<template>
  <div data-app>
    <Header />
    <div class="container webinar-form" style="margin-top: 84px">
      <div class="row">
        <div class="col-12 col-md-6">
          <h1 class="h1 font-weight-normal text-md-left">{{workshopData.webinar_name}}</h1>
          <h2 class="h5 font-weight-light my-4 text-left">{{workshopData.webinar_description}}</h2>
          <img :src="workshopData.webinar_banner" class="img-fluid mt-2 mb-md-5 mb-3">
        </div>
        <div class="col-12 col-md-6 justify-content-center">
          <template>
            <v-row justify="center">
              <v-dialog
                v-model="dialog"
                persistent
                max-width="60%"
                class="j-dialog"
              >
                <v-card class="d-flex flex-column " style="align-items: center;">
                  <v-card-title class="j-card-title">
                    Success
                  </v-card-title>
                  <v-card-text class="j-card-text">{{responseMessage}}</v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      class="j-button"
                      style = "color:white;margin:1rem;background:rgb(25, 153, 238)!important"
                      text
                      @click="dialog = false;send_email(workshopData.email_body,$v.form_detail.email.$model)"
                    >
                      Close
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </template>
          <!-- <b-card-body class="p-0">  -->
            <b-form class="px-md-5 px-2 pb-4 form-row" v-if="registerScreen">
              <b-form-group class="col-lg-6 text-left py-0" id="form1" label="First Name" label-for="first_name">
                <b-form-input id="first_name" v-model="$v.form_detail.firstName.$model" type="text" placeholder="Enter First Name" autocomplete="off">
                </b-form-input>
                <small class="text-danger" v-if="$v.form_detail.firstName.$anyError">(Please enter valid first name)</small>
              </b-form-group>
              <b-form-group class="col-lg-6 text-left py-0" id="form2" label="Last Name" label-for="last_name">
                <b-form-input id="last_name" v-model="$v.form_detail.lastName.$model" type="text" placeholder="Enter Last Name" autocomplete="off">
                </b-form-input>
                <small class="text-danger" v-if="$v.form_detail.lastName.$anyError">(Please enter valid last name)</small>
              </b-form-group>
              <b-form-group class="col-12 text-left py-0" id="form3" label="Email" label-for="email">
                <b-form-input id="email" v-model="$v.form_detail.email.$model" type="email" placeholder="Enter Email" autocomplete="off">
                </b-form-input>
                <small class="text-danger" v-if="$v.form_detail.email.$anyError">(Please enter valid email name)</small>
              </b-form-group>
              <b-form-group class="col-12 text-left py-0" id="form4" label="Phone Number" label-for="phone">
                <b-form-input id="phone" v-model="$v.form_detail.phone.$model" type="text" placeholder="Enter Phone Number" autocomplete="off">
                </b-form-input>
                <small class="text-danger" v-if="$v.form_detail.phone.$anyError">(Please enter valid phone number)</small>
              </b-form-group>
             <b-form-group class="col-12 text-left py-0" id="form5" label="School" label-for="schools" v-if="workshopData.school_required == 'yes'">
                <b-form-select id="schools" v-model="$v.form_detail.school.$model" :options="schools" autocomplete="off">
                </b-form-select>
                <small class="text-danger" v-if="$v.form_detail.school.$anyError">(Please select school)</small>
              </b-form-group>
              <b-button class="m-auto" :disabled="$v.form_detail.$invalid" type="button" variant="primary" @click="registerSubmit">Submit</b-button>
            </b-form>
            <b-form class="px-md-5 px-2 pb-4" v-if="otpScreen">
                 <b-form-group class="col-12 text-left p-0" id="form6" label="OTP" label-for="otp">
                  <b-form-input id="otp" v-model="$v.form_otp.otp.$model" type="text" placeholder="Enter OTP" autocomplete="off">
                  </b-form-input>
                  <small class="text-danger" v-if="$v.form_otp.otp.$anyError">(Please enter OTP)</small>
                </b-form-group>
                <b-button class="m-auto" :disabled="$v.form_otp.$invalid" type="button" variant="primary" @click="submitOTP(workshopData.success_message)">Submit</b-button>
            </b-form>
          <!-- </b-card-body> -->
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import {  mapActions } from "vuex";
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength, email, numeric, alpha } from 'vuelidate/lib/validators'
export default {
  name: "workshop",
  mixins: [validationMixin],
  components: {
        Header,
        Footer
    },
  data() {
    return {
      schools: [{ text: "Select School", value: ""}],
      dialog: false,
      workshopData: [],
      registerScreen: false,
      otpScreen: false,
      responseMessageShow: false,
      responseMessage: "",
      user_id: "",
      form_detail: {
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        school: '' 
      },
      form_otp:{
         otp: ""
      }
    }
  },
  validations: {
      form_detail: {
        firstName: { required, alpha },
        lastName: { required, alpha },
        phone: { required, numeric, minLength: minLength(10), maxLength: maxLength(10)},
        email: { required,email },
        school: { required}
      },
      form_otp: {
        otp: {required}
      }
  },
  watch: {
    workshopData : function(newVal,oldVal){
      if(newVal.school_required == 'no'){
        this.form_detail.school = "not required"
      }
    }
  },
  methods: {
      ...mapActions(["sendOTP"]),
      async send_email(value,email){
        let BASE_URL = process.env.NODE_ENV === "production" ? process.env.VUE_APP_API_URL : "https://localhost:3000";
        const payload = {
          "body": value,
          "email": email,
          "api_key" : "$2a$08$au3osMSeEIJP5xfArdArYOdaDnf7JXOc355RsOoVaqcCrhGhY3Nee"
        }
        const sendEmail = await this.$http.post(`${BASE_URL}/emails/webinarEmail`,payload);
        // console.log(sendEmail.status);
        if(sendEmail.status === 200)
        {
          this.$router.go();
          // console.log("success");
        }
        else {
          console.log("error"); 
        }
      },
       async registerSubmit(){
          let loader = this.$loading.show({})
        const PhoneNo = "+91"+this.$v.form_detail.phone.$model 
        const guestUserPayload = {
          "first_name": this.$v.form_detail.firstName.$model,
          "last_name": this.$v.form_detail.lastName.$model,
          "email": this.$v.form_detail.email.$model,
          "phone": PhoneNo,
          "source": `avishkaar.cc/workshop/${this.$route.params.workshop_code}`
        }
        let BASE_URL = process.env.NODE_ENV === "production" ? process.env.VUE_APP_API_URL : "https://localhost:3000";
        try{
          const guestRegister = await this.$http.post(`${BASE_URL}/users/guest/register`,guestUserPayload);
          this.sendOTP(PhoneNo).then(result => {
            this.user_id = guestRegister.data.data.userId
            this.registerScreen = false;
            this.otpScreen = true;
            loader.hide()
          }).catch(error => {
            this.responseMessageShow = true;
            this.responseMessage = error;
          })
        }catch(error){
          this.responseMessageShow = true;
          this.responseMessage = error;
        }
      },
      async submitOTP(success_msg){
        const otp  = localStorage.getItem("otp")
        if(otp == this.$v.form_otp.otp.$model){
            const registerUserPayload = {
              "user_id": this.user_id,
              "webinar_code": this.$route.params.workshop_code,
              "school": this.$v.form_detail.school.$model
            }
            let BASE_URL = process.env.NODE_ENV === "production" ? process.env.VUE_APP_API_URL : "https://localhost:3000";
            try{
              const webinarRegister = await this.$http.post(`${BASE_URL}/campaigns/webinar/register`,registerUserPayload);
              this.otpScreen = false;
              this.responseMessageShow = true;
              this.responseMessage = success_msg;
              this.dialog = true;
              
            }catch(error){
              this.responseMessageShow = true;
              this.responseMessage = error.response.data.error;
            }
        }else{
          this.responseMessageShow = true;
          this.responseMessage = "Invalid OTP";
        }
      },
      async getWorkshopData(){
          let BASE_URL = process.env.NODE_ENV === "production" ? process.env.VUE_APP_API_URL : "https://localhost:3000";
          try{
              const response = await this.$http.get(`${BASE_URL}/campaigns/webinar/${this.$route.params.workshop_code}`);
              this.workshopData = response.data.data;
              const schoolRespone = await this.$http.get(`${BASE_URL}/schools/getZohoSchools`)
              const schoolDetails = schoolRespone.data.data;
              schoolDetails.map(school => {
                this.schools.push({ text: school.school_name, value: school.school_name})
              })
              this.registerScreen = true
          }catch(error){
              this.responseMessageShow = true;
              this.responseMessage = error;
          }
      }
  },
  created() {
    document.title = "Avishkaar Workshop";
    this.getWorkshopData();
  }
};
</script>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins&family=Roboto:wght@300;400&display=swap');
</style>
<style lang="scss">
.webinar-form {
  label {  
  font-family: Poppins;
  }
  h1, h2 {
    font-family: Roboto !important;
  }
  .form-control:focus {
    border-color: #f36f2e;
    border: 2px solid #f36f2e;
    box-shadow: none;
  }
  .custom-select:focus {
    border-color: #f36f2e;
    border: 2px solid #f36f2e;
    box-shadow: none;
  }
  .btn-primary {
    margin-left: 5px;
  }
  .btn-primary.disabled, .btn-primary:disabled {
      color: #fff;
      background-color: #8d8d8d;
      border-color: #8d8d8d;
  }
}
</style>
<style>
.j-card-title {
  justify-content: center;
  font-size: 3rem!important;
  padding: 24px 24px 10px;
}
.j-card-text {
  line-height: 2rem;
  color:black!important;font-weight:400!important;font-size:2rem;padding: 5%!important;
}
.j-button {
  color: white;
  background: green;
  font-size: 1rem;
}

@media (max-width: 992px)
{
  .j-card-title {
    justify-content: center;
    font-size: 2.75rem!important;
    padding: 24px 24px 10px;
  }
  .j-card-text {
    color:black!important;font-weight:400!important;font-size:1.75rem;padding: 5%!important;
  }
  .j-button {
    color: white;
    background: green;
    font-size: 0.85rem;
  }  
}
@media (max-width: 720px)
{
  .j-card-title {
    justify-content: center;
    font-size: 2.5rem!important;
    padding: 24px 24px 10px;
  }
  .j-card-text {
    color:black!important;font-weight:400!important;font-size:1.5rem;padding: 5%!important;
  }
  .j-button {
    color: white;
    background: green;
    font-size: 0.75rem;
  }  
}
@media (max-width: 576px)
{
  .j-dialog {
    max-width: 70%!important;
  }
  .j-card-title {
    justify-content: center;
    font-size: 2.25rem!important;
    padding: 24px 24px 10px;
  }
  .j-card-text {
    color:black!important;font-weight:400!important;font-size:1.25rem;padding: 5%!important;
  }
  .j-button {
    color: white;
    background: green;
    font-size: 0.5rem;
  }  
}
</style>
